import SDKVerification from "../../../../src/mdx/sdk/verification.mdx";
import * as React from 'react';
export default {
  SDKVerification,
  React
};